import angular from 'angular';

export const App = angular.module('App', ['hmTouchEvents', 'colorpicker', 'angularjs-gauge', 'angularMoment', 'chart.js', 'tmh.dynamicLocale']);
